import axios from '../../axios';
import { toast } from 'react-toastify';
import {
   REPORT_PURCHASE_DETAIL,
   REPORT_SALES_DETAIL,
   REPORT_OUTSTANDING_DETAIL,
   REPORT_STOCK_DETAIL,
   REPORT_PURCHASE_SUMMARY,
   REPORT_TDS,
   REPORT_LEDGER,
   REPORT_SALE_SUMMARY,
   REPORT_ITEM_BY_CONTACT,
   REPORT_INVENTORY_DETAIL,
   CLEAR_CACHE_REPORT,
   REPORT_BILL_TO_BILL,
   REPORT_TRIAL_BALANCE,
   REPORT_TRIAL_BALANCE_GLGROUP_WISE,
   REPORT_TRIAL_BALANCE_FULL,
   REPORT_BALANCE_SHEET,
   REPORT_BALANCE_SHEET_SUMMARY,
   REPORT_SERIALWISE_HISTORY,
   REPORT_BALANCE_SHEET_VERTICAL,
   REPORT_PROFIT_LOSS_MONTHLY,
   REPORT_STORE_STOCK,
   REPORT_STORE_STOCK_FOR_RECEIVE,
   REPORT_B2B_SALES,
   REPORT_B2CL_SALES,
   REPORT_B2CS_SALES,
   REPORT_CDNR_SALES,
   REPORT_CDNUR_SALES,
   REPORT_EXP_SALES,
   REPORT_EXEMP_SALES,
   REPORT_HSNB2B_SALES,
   REPORT_HSNB2C_SALES,
   REPORT_DOC_SALES,
   REPORT_GSTR3B,
   REPORT_FORMAT,
   UPDATE_REPORT_FORMAT,
   ADD_REPORT_FORMAT,
   DELETE_REPORT_FORMAT,
   REPORT_ALL_TRANSACTION,
   GSTR_EXCEL_GENERATE_START,
   GSTR_EXCEL_GENERATE_SUCCESS,
   GSTR_EXCEL_GENERATE_ERROR,
   GSTR_EXCEL_DOWNLOAD_START,
   GSTR_EXCEL_DOWNLOAD_SUCCESS,
   GSTR_EXCEL_DOWNLOAD_ERROR,
   GSTR_2AB2B_RECONCILATION,
   REPORT_NONE_SERIALISED_PROFIT,
   REPORT_PURCHASE_ORDER_DETAIL,
   REPORT_PURCHASE_CHALLAN_DETAIL,
   REPORT_SALE_ORDER_DETAIL,
   REPORT_SALE_CHALLAN_DETAIL,
   REPORT_MILL_ISSUE_DETAIL,
   REPORT_GRAY_PURCHASE_DETAIL,
   REPORT_STATEMENT,
   REPORT_OUTSTANDING,
} from '../types';
import { downloadBase64File } from '../../utils/util.js';

export const getReportSaleDetail = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/salesdetail', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_SALES_DETAIL, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.status === 500) {
         toast.error(err.response.message);
         return;
      }
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getReportSaleOrderDetail = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/salesOrderdetail', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_SALE_ORDER_DETAIL, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.status === 500) {
         toast.error(err.response.message);
         return;
      }
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getReportSaleChallanDetail = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/salesChallanDetail', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_SALE_CHALLAN_DETAIL, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.status === 500) {
         toast.error(err.response.message);
         return;
      }
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getReportPurchaseDetail = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/purchasedetail', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_PURCHASE_DETAIL, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.status === 500) {
         toast.error(err.response.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};


export const getReportPurchaseOrderDetail = (params) => async (dispatch) => {
   try {
      // ✅ Clear old data BEFORE fetching new data
      dispatch({ type: REPORT_PURCHASE_ORDER_DETAIL, payload: [] });

      const res = await axios.get('/reports/purchaseOrderdetail', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_PURCHASE_ORDER_DETAIL, payload: res.data.data || [] });
      }

   } catch (err) {
      // ✅ Also clear on error so stale data doesn't show
      dispatch({ type: REPORT_PURCHASE_ORDER_DETAIL, payload: [] });

      if (err.response.status === 500) {
         toast.error(err.response.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getReportPurchaseChallanDetail = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/purchaseChallandetail', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_PURCHASE_CHALLAN_DETAIL, payload: res.data.data || [] });
      }

   } catch (err) {
      if (err.response.status === 500) {
         toast.error(err.response.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getReportTds = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/tds', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_TDS, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.status === 404) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getReportLedger = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/ledger', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_LEDGER, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getSatementReport = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/ledger', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_STATEMENT, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getBillToBillProfit = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/billToBillProfit', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_BILL_TO_BILL, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getNoneSerialisedProfit = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/noneSerialisedProfit', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_NONE_SERIALISED_PROFIT, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getReportOutstandingDetail = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/os', { params });
      if (res.data.code === 1) {
         dispatch({ type: REPORT_OUTSTANDING_DETAIL, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getReportOutstanding = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/os', { params });
      if (res.data.code === 1) {
         dispatch({ type: REPORT_OUTSTANDING, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getItemByContactReport = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/item-by-contact', { params });
      if (res.data.code === 1) {
         dispatch({ type: REPORT_ITEM_BY_CONTACT, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getInventoryDetailReport = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/item-ledger', { params });
      if (res.data.code === 1) {
         dispatch({ type: REPORT_INVENTORY_DETAIL, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getReportStockDetail = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/salesLineDetail/multicompanyStock', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_STOCK_DETAIL, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getReportSerialWiseHistory = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/salesLineDetail/serialWiseHistory', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_SERIALWISE_HISTORY, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const clearCacheReport = () => ({
   type: CLEAR_CACHE_REPORT,
});

export const getTrialBalance = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/trialBalanceFull', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_TRIAL_BALANCE_FULL, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getTrialBalanceGLGroupWise = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/trialBalanceFullGlGroup', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_TRIAL_BALANCE_GLGROUP_WISE, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getTrialBalanceFull = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/trialBalance', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_TRIAL_BALANCE, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getBalanceSheet = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/balanceSheet', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_BALANCE_SHEET, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getbalanceSheetSummary = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/balanceSheetSummary', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_BALANCE_SHEET_SUMMARY, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getbalanceSheetVertical = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/balanceSheetVertical', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_BALANCE_SHEET_VERTICAL, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getProfitLossMonthly = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/monthlyPNL', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_PROFIT_LOSS_MONTHLY, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getStoreStock = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/storeStockReport', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_STORE_STOCK, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getStoreStockForReceive = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/storeStock', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_STORE_STOCK_FOR_RECEIVE, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getB2BSales = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/B2Bsales', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_B2B_SALES, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getB2CLSales = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/B2CLsales', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_B2CL_SALES, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getB2CSSales = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/B2CSsales', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_B2CS_SALES, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getCDNRSales = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/CDNR', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_CDNR_SALES, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getCDNURSales = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/CDNUR', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_CDNUR_SALES, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getEXPSales = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/EXPsales', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_EXP_SALES, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getEXEMPSales = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/EXEMPTsales', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_EXEMP_SALES, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};
export const getHSNB2BSales = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/HSNB2Bsales', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_HSNB2B_SALES, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getHSNB2CSales = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/HSNB2Csales', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_HSNB2C_SALES, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getDOCSSales = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/GSTDOCSsales', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_DOC_SALES, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getGSTR3B = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/GST3B', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_GSTR3B, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getReportFormat = () => async (dispatch) => {
   try {
      const res = await axios.get('/reportformat/all');

      if (res.data.code === 1) {
         dispatch({ type: REPORT_FORMAT, payload: res.data.data });
         return res.data.data;
      } else {
         toast.error(res.data.message || 'Failed to fetch report formats');
         return null;
      }
   } catch (err) {
      if (err.response) {
         if (err.response.status === 404 || err.response.status === 500) {
            toast.error('Issue From Server');
         } else if (err.response.data?.errors?.[0]?.message) {
            toast.error(err.response.data.errors[0].message);
         } else {
            toast.error(err.response.data?.message || 'An error occurred');
         }
      } else {
         toast.error('Network error - please check your connection');
      }
      return null;
   }
};

export const addReportFormat = (format) => async (dispatch) => {
   try {
      const res = await axios.post('/reportformat/add', format);

      if (res.data.code === 1) {
         dispatch({ type: ADD_REPORT_FORMAT, payload: res.data.data });
         // Refresh the formats after adding
         toast.success('Report format added successfully');
         return { payload: res.data.data };
      } else {
         toast.error(res.data.message || 'Failed to add report format');
      }
   } catch (err) {
      if (err.response && err.response.data?.errors?.[0]?.message) {
         toast.error(err.response.data.errors[0].message);
      } else {
         toast.error('An error occurred while adding the report format');
      }
   }
};

export const updateReportFormat = (format) => async (dispatch) => {
   try {
      const res = await axios.post('/reportformat/update', format);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_REPORT_FORMAT, payload: res.data.data });
         toast.success('Report format updated successfully');
      } else {
         toast.error(res.data.message || 'Failed to update report format');
      }
   } catch (err) {
      if (err.response && err.response.data?.errors?.[0]?.message) {
         toast.error(err.response.data.errors[0].message);
      } else {
         toast.error('An error occurred while updating the report format');
      }
   }
};

export const deleteReportFormat = (formatId) => async (dispatch) => {
   try {
      const res = await axios.post(`/reportformat/delete/${formatId}`, { id: formatId });

      if (res.data.code === 1) {
         dispatch({ type: DELETE_REPORT_FORMAT, payload: { id: formatId } });
         toast.success('Report format deleted successfully');
      } else {
         toast.error(res.data.message || 'Failed to delete report format');
      }
   } catch (err) {
      if (err.response && err.response.data?.errors?.[0]?.message) {
         toast.error(err.response.data.errors[0].message);
      } else {
         toast.error('An error occurred while deleting the report format');
      }
   }
};

export const getAllTransaction = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/allTransaction', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_ALL_TRANSACTION, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const generateGSTRExcel = (requestData) => async (dispatch) => {
   dispatch({ type: GSTR_EXCEL_GENERATE_START });

   try {
      const res = await axios.post('/gstr-excel/generate', requestData);

      if (res.data.code === 1) {
         dispatch({
            type: GSTR_EXCEL_GENERATE_SUCCESS,
            payload: res.data.data,
         });

         // Auto-download the file
         const { fileName, fileContent } = res.data.data;
         downloadBase64File(fileContent, fileName);

         toast.success(`GSTR1 ${requestData.reportType} Excel generated successfully`);
         return res.data.data;
      } else {
         throw new Error(res.data.message || 'Failed to generate Excel');
      }
   } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Error generating Excel';

      dispatch({
         type: GSTR_EXCEL_GENERATE_ERROR,
         payload: errorMessage,
      });

      if (err.response?.status === 404 || err.response?.status === 500) {
         toast.error('Issue From Server');
      } else {
         toast.error(errorMessage);
      }
      throw err;
   }
};

export const generateAllGSTRReports = (requestData) => async (dispatch) => {
   dispatch({ type: GSTR_EXCEL_GENERATE_START });

   try {
      const res = await axios.post('/gstr-excel/generate-all', requestData);

      if (res.data.code === 1) {
         dispatch({
            type: GSTR_EXCEL_GENERATE_SUCCESS,
            payload: res.data.data,
         });

         toast.success(
            `All GSTR1 reports generated successfully. Total: ${res.data.data.successCount}/${res.data.data.totalReports}`,
         );
         return res.data.data;
      } else {
         throw new Error(res.data.message || 'Failed to generate reports');
      }
   } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Error generating reports';

      dispatch({
         type: GSTR_EXCEL_GENERATE_ERROR,
         payload: errorMessage,
      });

      if (err.response?.status === 404 || err.response?.status === 500) {
         toast.error('Issue From Server');
      } else {
         toast.error(errorMessage);
      }
      throw err;
   }
};

export const downloadGSTRExcelFile = (fileName, filePath) => async (dispatch) => {
   dispatch({ type: GSTR_EXCEL_DOWNLOAD_START });

   try {
      const res = await axios.get(`/gstr-excel/download/${fileName}`, {
         params: { filePath },
         responseType: 'blob',
      });

      // Create download link
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      dispatch({ type: GSTR_EXCEL_DOWNLOAD_SUCCESS });
      toast.success('File downloaded successfully');
   } catch (err) {
      const errorMessage = err.response?.data?.error || err.message || 'Error downloading file';

      dispatch({
         type: GSTR_EXCEL_DOWNLOAD_ERROR,
         payload: errorMessage,
      });

      if (err.response?.status === 404) {
         toast.error('File not found');
      } else if (err.response?.status === 500) {
         toast.error('Issue From Server');
      } else {
         toast.error(errorMessage);
      }
      throw err;
   }
};

export const getGSTR2AB2BReconcilation = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/GSTR2AB2B', { params });
      if (res.data.code === 1) {
         const error = res.data?.data?.data?.code;
         if (error === 'EDIT_COMPANY') {
            toast.error(res.data?.data?.message);
            return res.data?.data?.data;
         }
         if (error === 'EDIT_COMPANY_SETTING') {
            toast.error(res.data?.data?.message);
            return res.data?.data?.data;
         }
         if (error === 'GST_OTP') {
            toast.error(res.data?.data?.message);
            return res.data?.data?.data;
         }
         dispatch({ type: GSTR_2AB2B_RECONCILATION, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.status === 500) {
         toast.error(err.response.message);
         return;
      }
      if (err.response.data.message) {
         // toast.error(err.response.data.message);
      }
   }
};

export const exportGSTR1Json = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/exportGSTR1Json', { params });
      return res.data;
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const statementCheckedStyle = (data) => async (dispatch) => {
   try {
      const res = await axios.post('/reports/checkedStyle', data);
      dispatch({ type: 'STATEMENT_CHECKED_STYLE', payload: res.data.data });
      return res.data;
   } catch (err) {
      if (err.response.status === 404 || err.response.status === 500) {
         toast.error('Issue From Server');
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};


export const getReportMillIssue = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/millIssueDetail', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_MILL_ISSUE_DETAIL, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.status === 500) {
         toast.error(err.response.message);
         return;
      }
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};


export const getReportGrayPurchase = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/reports/grayPurchasedetail', { params });

      if (res.data.code === 1) {
         dispatch({ type: REPORT_GRAY_PURCHASE_DETAIL, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.status === 500) {
         toast.error(err.response.message);
         return;
      }
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
